import { render, staticRenderFns } from "./ClientForm.vue?vue&type=template&id=39331adc&scoped=true"
import script from "./ClientForm.vue?vue&type=script&lang=js"
export * from "./ClientForm.vue?vue&type=script&lang=js"
import style0 from "./ClientForm.vue?vue&type=style&index=0&id=39331adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39331adc",
  null
  
)

export default component.exports